import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const token = localStorage.getItem('token');
  const cliente = JSON.parse(localStorage.getItem('cliente') || '{}');

  // Se não tem token, redireciona para login
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Se requer admin mas não é admin, redireciona
  if (requireAdmin && !cliente.is_admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

